import { useDelay } from '@src/utils/common-util';

let isLoaded = false;
const { run } = useDelay();

/**
 * 模块：字体注入助手
 *
 * 说明：该模块通过向 document.head 插入 style 标签，登记页面所需的本地 woff2 字体。
 * 字体使用 `font-display: swap` 以避免阻塞首次渲染（FOUT 处理）。
 */
function injectFonts() {
  const style = document.createElement('style');
  style.innerText = `
    @font-face {
      font-family: 'MiSans-Semibold';
      src: url(${require('./MiSans-Semibold.woff2')}) format('woff2');
      font-display: swap; /* 避免阻塞渲染 */
    }

    @font-face {
      font-family: 'MiSans-Regular';
      src: url(${require('./MiSans-Regular.woff2')}) format('woff2');
      font-display: swap; /* 避免阻塞渲染 */
    }
  `;
  document.head.appendChild(style);
}

/**
 * 延迟或立即加载页面字体
 *
 * @param {Object} [options={}] 配置项
 * @param {number} [options.delay=0] 延迟时间（毫秒）。当 `immediate` 为 `false` 时生效。
 *   注意：`setTimeout` 在 0 毫秒时也可能出现延迟（见 MDN 关于最小延迟的说明）。
 * @param {boolean} [options.immediate=false] 是否立即注入字体；为 `true` 时忽略 `delay`。
 * @returns {void}
 *
 * @example
 * // 立即加载字体（忽略 delay）
 * loadFonts({ immediate: true });
 *
 * // 延迟 1 秒加载字体
 * loadFonts({ delay: 1000 });
 *
 * @remarks
 * - 本函数具有副作用：会向 `document.head` 插入 `<style>` 节点，且只会执行一次（通过内部 `isLoaded` 保护）。
 * - 服务端渲染（SSR）场景下请勿直接调用；在客户端入口处或 effect 中调用更安全。
 */
export function loadFonts({ delay = 0, immediate = false } = {}) {
  if (isLoaded) return;
  isLoaded = true;

  if (immediate) {
    injectFonts();
    return;
  }

  run(delay).then(() => {
    injectFonts();
  });
}
